<div class="supplier-tabs" [formGroup]="form">
  <div class="form-group">
    <label class="control-label col-md-4">Max LOI</label>
    <div class="col-md-6">
      <input
        name="max_loi"
        type="number"
        placeholder="Max LOI"
        class="form-control input-md"
        formControlName="max_loi"
        (keyup)="validateLOI($event)"
      />
    </div>
  </div>
  <div class="form-group">
    <label class="control-label col-md-4">Min Incidence</label>
    <div class="col-md-6">
      <input
        name="min_incidence"
        type="number"
        placeholder="Min Incidence"
        class="form-control input-md"
        formControlName="min_incidence"
      />
    </div>
  </div>
  <div class="form-group">
    <label class="col-md-4 control-label"> Recontact</label>
    <div class="col-md-6">
      <label class="radio-inline">
        <input
          type="radio"
          name="isRecontact"
          id="Recontact"
          [value]="true"
          formControlName="isRecontact"
        />
        Yes
      </label>
      <label class="radio-inline">
        <input
          type="radio"
          name="isRecontact"
          [value]="false"
          formControlName="isRecontact"
        />
        No
      </label>
    </div>
  </div>
</div>
